import { createGlobalStyle } from 'styled-components';
import mainColors from '../Style-guide/main-colors';

const GlobalStyles = createGlobalStyle`

 body {
    margin: 0;
    padding: 0;
    background-color: ${mainColors.dark_background};
    color: ${mainColors.text_color};
    -webkit-tap-highlight-color: transparent;
   }

  ::-webkit-scrollbar {
    width: 4px; 
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(
    to top,
    ${mainColors.main_color_rgba(0.5)},
    ${mainColors.main_color_rgba(1)},
    ${mainColors.main_color_rgba(0.5)}
  );
    border-radius: 8px; 
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: ${mainColors.main_color}; 
  }
  ::-webkit-scrollbar-track {
    background: ${mainColors.dark_background}; 
  }

`;
export default GlobalStyles;
